// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--g9xZK","icon":"_0fce717cdb--icon--BfCwc","content":"_0fce717cdb--content--RdaeL"};